<template>
  <ion-header>
    <ion-toolbar>
      <ion-title>
        <HomeButton/>  Door 42
      </ion-title>
    </ion-toolbar>
  </ion-header>

  <ion-content class="auth-form">
    <ion-grid>
      <ion-row>
        <ion-col align-self-center>
          <h1>Willkommen</h1>
          <p class="ion-padding">
            Diese Anwendung wird Ihnen helfen, sich selbst und andere besser kennen zu lernen und
            so Ihr Leben zufriedener und besser zu meistern.
          </p>

          <ion-button :routerLink="{name:'Register'}" expand="block" color="primary">Registrieren</ion-button>
          <div class="divider">Oder haben Sie bereits einen Account?</div>
          <ion-button :routerLink="{name:'Login'}" expand="block" color="danger">Anmelden</ion-button>
          <p style="text-align: center" class="ion-padding">Mit der Nutzung unsere Dienste sind Sie mit unseren <a href="/legal/">Datenschutzbestimmungen</a> einverstanden</p>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-content>
</template>

<script lang="ts">
import {defineComponent} from 'vue';
import {createI18n, useI18n} from "vue-i18n";
import {RouterLink, useRouter} from "vue-router";

import {
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  IonButton,
} from "@ionic/vue";
import HomeButton from "@/components/HomeButton.vue";

export default defineComponent({
  name:'Init',
  components:{
    HomeButton,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonGrid,
    IonRow,
    IonCol,
    IonButton,
  }
})
</script>

<style scoped>

.divider{
  text-align:center;
  margin-top:20px;
  margin-bottom:20px;
  color: var(--ion-color-medium-tint,#000);
}
</style>
